/**
 * Wishlist API Client - Otimizado
 * Sistema de gerenciamento de favoritos usando API REST
 * @version 2.0
 */

(function ($) {
    'use strict';

    const WishlistAPI = {
        baseURL: '/wp-json/api/v1/wishlist',

        getHeaders: function() {
            return {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Pragma': 'no-cache',
                'X-Requested-With': 'XMLHttpRequest',
                'X-WP-Nonce': wpApiSettings?.nonce || '',
            };
        },

        toggle: function(productId) {
            return $.ajax({
                url: this.baseURL + '/toggle',
                type: 'POST',
                data: { product_id: productId },
                headers: this.getHeaders(),
                dataType: 'json',
                cache: false,
            });
        },

        check: function(productId) {
            return $.ajax({
                url: this.baseURL + '/check',
                type: 'GET',
                data: { product_id: productId, _: Date.now() },
                headers: this.getHeaders(),
                dataType: 'json',
                cache: false
            });
        },

        list: function() {
            return $.ajax({
                url: this.baseURL + '/list',
                type: 'GET',
                data: { _: Date.now() },
                headers: this.getHeaders(),
                dataType: 'json',
                cache: false
            });
        }
    };

    function initWishlist() {
        // Handler de clique no botão de favorito
        $(document).on('click', '.product-thumb-header-favorite', function(e) {
            e.preventDefault();
            const $button = $(this);
            let productId = $button.data('product-id');

            // Fallback: converte URL → ID se necessário
            if (!productId) {
                const productUrl = $button.closest('.product-thumb--inner').find('a').attr('href');
                if (!productUrl) return;

                $.ajax({
                    url: ajaxScript.ajaxurl,
                    type: 'POST',
                    data: { action: 'url_to_postid', url: productUrl },
                    success: function(response) {
                        const postId = parseInt(response?.data);
                        if (postId > 0) toggleWishlistItem($button, postId);
                    }
                });
                return;
            }

            toggleWishlistItem($button, productId);
        });

        // Marca favoritos ao carregar a página - APENAS se usuário estiver logado
        if ($('body').hasClass('logged-in')) {
            WishlistAPI.list().done(function(response) {
                if (response.status && response.data.products) {
                    const favoriteIds = response.data.products.map(p => p.id);
                    $('.product-thumb-header-favorite').each(function() {
                        const productId = $(this).data('product-id');
                        if (favoriteIds.includes(productId)) {
                            $(this).addClass('active');
                        }
                    });
                }
            });
        }
    }

    function toggleWishlistItem($button, productId) {
        $button.prop('disabled', true).addClass('loading');

        WishlistAPI.toggle(productId)
            .done(function(response) {
                if (response.status) {
                    $button.toggleClass('active', response.data.action === 'added');
                    displayMessage('success', response.message);
                } else {
                    displayMessage('error', response.message || 'Erro ao processar favorito');
                }
            })
            .fail(function(xhr) {
                const errorMessage = xhr.status === 401
                    ? 'Você precisa estar logado para adicionar favoritos'
                    : xhr.responseJSON?.message || 'Erro ao processar favorito';
                displayMessage('error', errorMessage);
            })
            .always(function() {
                $button.prop('disabled', false).removeClass('loading');
            });
    }

    function displayMessage(status, message) {
        const $modal = $('#modal');
        const $tag = $modal.find('#tag');

        const statusConfig = {
            success: { text: 'Pronto!', class: 'success' },
            error: { text: 'Opa...', class: 'error' },
            info: { text: 'Aviso', class: 'warning' }
        };

        const config = statusConfig[status] || statusConfig.info;

        $tag.text(config.text).removeClass('success error warning').addClass(config.class);
        $modal.find('#text-content').html(`<span id="message">${message}</span>`);
        $modal.fadeIn();

        setTimeout(() => $modal.fadeOut(), 3000);
    }

    $(document).ready(initWishlist);
    window.WishlistAPI = WishlistAPI;

})(jQuery);
